import { useMutation, useQuery } from '@tanstack/react-query';
import { API_ENDPOINTS } from 'constants/endpoints';
import { get, handleError, handleResponse, post } from './base.service';

export const useGetTemplateListQuery = (params: string = '') =>
	useQuery({
		queryFn: async () => {
			try {
				const response = await get(`${API_ENDPOINTS.RESUME_TEMPLATES}?${params}`);
				return handleResponse(response);
			} catch (err) {
				handleError(err);
			}
		},
		queryKey: ['get-template-list'],
	});
export const useGetTemplateDetailsQuery = (params: number | null = null) =>
	useQuery({
		queryFn: async () => {
			try {
				const response = await get(`${API_ENDPOINTS.RESUME_TEMPLATE_DETAILS}/${params}`);
				return handleResponse(response);
			} catch (err) {
				handleError(err);
			}
		},
		queryKey: ['get-template-details'],
		enabled: !!params,
	});

export const useGetDownloadResumeQuery = (params: boolean = false) =>
	useQuery({
		queryFn: async () => {
			try {
				const response = await get(`${API_ENDPOINTS.RESUME_TEMPLATE_DOWNLOAD}`);
				return handleResponse(response);
			} catch (err) {
				handleError(err);
			}
		},
		queryKey: ['get-template-download'],
		enabled: params,
	});

export const useGetCommonDataQuery = () =>
	useQuery({
		queryFn: async () => {
			try {
				const response = await get(`${API_ENDPOINTS.RESUME_TEMPLATE_DATA_LIST}`);
				return handleResponse(response);
			} catch (err) {
				handleError(err);
			}
		},
		queryKey: ['get-template-data-list'],
	});

export const useDownloadResumeMutation = () =>
	useMutation({
		mutationFn: (payload: any) => {
			return post(API_ENDPOINTS.RESUME_TEMPLATE_DOWNLOAD, payload);
		},
		onSuccess: handleResponse,
		onError: handleError,
	});

export const useDownloadResumeMobileMutation = () =>
	useMutation({
		mutationFn: (payload: any) => {
			return post(API_ENDPOINTS.RESUME_TEMPLATE_DOWNLOAD_MOBILE, payload);
		},
		onSuccess: handleResponse,
		onError: handleError,
	});

export const useSaveResumeMutation = () =>
	useMutation({
		mutationFn: (payload: any) => {
			return post(API_ENDPOINTS.RESUME_TEMPLATE_SAVE, payload);
		},
		onSuccess: handleResponse,
		onError: handleError,
	});

export const useGetTemplateDetailsForMobileQuery = (
	templateId: number | null = null,
	accessToken: string = '',
) =>
	useQuery({
		queryFn: async () => {
			try {
				const response = await get(
					`${API_ENDPOINTS.RESUME_TEMPLATE_DETAILS_MOBILE}/${templateId}?accessToken=${decodeURI(accessToken)}`,
				);
				return response;
			} catch (err) {
				handleError(err);
			}
		},
		queryKey: ['get-template-details-for-mobile'],
		enabled: !!templateId && !!accessToken,
		refetchOnWindowFocus: false,
	});
